const _accordionBase = theme => ({
  boxShadow: 'none',
  backgroundColor: 'transparent',
  '::before': {
    visibility: 'hidden'
  }
});
const _uncontained = theme => ({
  ..._accordionBase(theme),
  borderBottomStyle: 'solid',
  borderBottomWidth: '1px',
  borderBottomColor: theme.tokens.ComponentAccordionBorderColor,
  marginBottom: '16px'
});
const _contained = theme => ({
  ..._accordionBase(theme),
  backgroundColor: theme.tokens.ComponentAccordionBg,
  borderStyle: 'solid',
  borderWidth: '1px',
  borderColor: theme.tokens.ComponentAccordionBorderColor,
  '& ~ &': {
    borderTopWidth: '0px'
  }
});
const accordionContainedDefaultStyle = (theme, contained) => {
  if (!contained) {
    return _uncontained(theme);
  } else {
    return _contained(theme);
  }
};
export default accordionContainedDefaultStyle;